var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { "data-qa": "case-images-slider" } }, [
    _c(
      "div",
      {
        staticClass: "b-swiper__track ga-4",
        attrs: { "data-qa": "case-images-slider_track" },
      },
      _vm._l(_vm.caseImages, function (caseImage, index) {
        return _c(_setup.CaseImage, {
          key: index,
          staticClass: "b-swiper__slide",
          attrs: {
            "case-image": caseImage,
            "image-width": 200,
            "image-height": 200,
            index: index,
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }